import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Row, Col } from 'antd';
import PreLayoutComponents from './components';
import Setup from './setup';
import SchematicSetup from './SchematicSetup';
import { MODEL, SCHEMATIC } from '../../../../services/Sierra/prelayout/prelayoutConstants';
import TopBar from './preLayoutTopBar';
import './index.css';
class PreLayout extends Component {


  getPreLayout = () => {
    const { prelayout, id, components, fixed } = this.props;

    if (prelayout === MODEL) {
      return components.length && id ? <Row className='space-16'>
        <Col span={24} className='sierra-pre-layout-setup-border'>
          <Setup fixed={fixed} />
        </Col>
      </Row> : null
    } else if (prelayout === SCHEMATIC) {
      return id ? <Row className='space-16'>
        <Col span={24} className='sierra-pre-layout-setup-border'>
          <SchematicSetup fixed={fixed} />
        </Col>
      </Row> : null
    }
  }

  render() {
    const { fixed } = this.props;
    return <Fragment>
      <TopBar
      />
      <div className='sierra-pre-layout-main'>
        <div className='sierra-pre-layout-body'>
          <Row>
            <Col span={24} className='sierra-pre-layout-setup-border'>
              <PreLayoutComponents fixed={fixed} />
            </Col>
          </Row>
          {this.getPreLayout()}
        </div>
      </div>
    </Fragment>
  }

}

const mapState = (state) => {
  const { SierraReducer: { prelayout: { components, id, prelayout }, /* project: { layout } */ } } = state;
  return {
    components,
    id,
    fixed: /* layout !== SINGLE_PAGE_LAYOUT ? true :  */false,//todo - Schematic topology cannot be modified in split screen mode
    prelayout
  }
}

const mapDispatch = (dispatch) => ({})

export default connect(mapState, mapDispatch)(PreLayout);
